import React from 'react'
import '../App.css'
import { Button } from './Button'
import { Link } from 'react-router-dom'

import './HeroSection.css'
import Icon from '../images/icon.svg'

function HeroSection() {
  return (
    <div className='hero-container'>
      <Link to='/' className='hero-logo'>
        <div className='hero-logo-container'>
          <img src={Icon} alt='MPULE Institute' className='hero-icon' />
          <div className='hero-title'>
            <h1 className='hero-mpule'>MPULE</h1>
            <h1 className='hero-foundation'>Foundation</h1>
          </div>
        </div>
      </Link>
      <div className='hero-text-container'>
        <p className='hero-text'>
          Investing in emerging agricultural technologies
        </p>
      </div>

      <div className='hero-btns'>
        <Button
          className='btn'
          buttonStyle='btn--outline'
          buttonSize='btn--medium'
          path='/about'
        >
          LEARN MORE
        </Button>
      </div>
    </div>
  )
}

export default HeroSection
